import React, { useState } from "react";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { FiUpload } from "react-icons/fi";

const documentFields = [
  {
    name: "directorPassport1",
    label: "Director 1 Passport",
    description: "*Only JPEG format & size must not be more than 100KB",
  },
  {
    name: "directorPassport2",
    label: "Director 2 Passport",
    description: "*Only JPEG format & size must not be more than 100KB",
  },
  {
    name: "companyProfile",
    label: "Company Profile",
    description:
      "*Only DOC and PNG are accepted & size must not be more than 200KB",
  },
  {
    name: "co7CacForm",
    label: "Co7 / CAC Form",
    description:
      "*Only DOC and PNG are accepted & size must not be more than 200KB",
  },
];

const CorporateUploadDocForm = ({
  handlePrevious,
  handleSaveRegLater,
  handleSubmit,
  loading,
  saveloading,
}) => {
  const [fileNames, setFileNames] = useState({});

  const handleFileChange = (event, setFieldValue, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Extract base64 data
        setFieldValue(fieldName, {
          extension: file.name.split(".").pop(),
          data: base64String,
        });
        setFileNames((prev) => ({ ...prev, [fieldName]: file.name }));
      };
    }
  };

  return (
    <Formik
      initialValues={documentFields.reduce(
        (acc, field) => ({ ...acc, [field.name]: { extension: "", data: "" } }),
        {}
      )}
      onSubmit={(values) => handleSubmit({ corporateDocumentUpload: values })}
    >
      {({ setFieldValue, errors, touched }) => (
        <Form>
          <Box p={5} w="100%" maxW="600px" mx="auto">
            <VStack spacing={8} align="stretch">
              {documentFields.map((doc, index) => (
                <FormControl
                  key={index}
                  isInvalid={errors[doc.name] && touched[doc.name]}
                >
                  <FormLabel fontWeight="bold">{doc.label}</FormLabel>
                  <Button
                    as="label"
                    htmlFor={doc.name}
                    cursor="pointer"
                    leftIcon={<Icon as={FiUpload} />}
                    colorScheme="green"
                    variant="solid"
                    w="100%"
                  >
                    Choose File
                  </Button>
                  <Input
                    id={doc.name}
                    type="file"
                    display="none"
                    onChange={(event) =>
                      handleFileChange(event, setFieldValue, doc.name)
                    }
                  />
                  <Text fontSize="sm" color="gray.500" mt={1}>
                    {fileNames[doc.name] || doc.description}
                  </Text>
                </FormControl>
              ))}
            </VStack>

            <Flex
              flexDirection={["column", "row"]}
              gap={["20px", "50px"]}
              alignItems={"center"}
              mt={["50px", "80px"]}
              mb={10}
            >
              <Button
                onClick={handlePrevious}
                bg="#A6A6A6"
                color="#FFFFFF"
                minW="150px"
              >
                Back
              </Button>
              <Button
                onClick={() => handleSaveRegLater()}
                bg="green.500"
                color="#FFFFFF"
                minW="220px"
                isLoading={saveloading}
              >
                Save and register later
              </Button>
              <Button
                type="submit"
                bg="#D11A2A"
                color="#FFFFFF"
                minW="220px"
                isLoading={loading}
              >
                Submit Registration
              </Button>
            </Flex>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default CorporateUploadDocForm;
